import React from 'react';

import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';
import Column from 'bloko/blocks/column';

import RequestForm from 'src/pages/ApplicantServicesOrder/components/CareerService/RequestForm';
import RequestPlanerkaForm from 'src/pages/ApplicantServicesOrder/components/CareerService/RequestPlanerkaForm';

const CreateRequest: React.FC = () => {
    const order = useSelectorNonNullable(({ careerServiceOrder }) => careerServiceOrder);
    const isPlanerka = order.isPlanerka;

    return (
        <Column xs="4" s="6" m="9" l="11" container>
            {isPlanerka ? <RequestPlanerkaForm /> : <RequestForm />}
        </Column>
    );
};

export default CreateRequest;
